export default "__VITE_ASSET__2416037f__"